"use client"

import { useState, useEffect, useMemo, useRef } from "react"
import Modal from "../modules/Modal/Moadal"
import InfoCard from "../modules/InfoCard/InfoCard"
import Button from "../modules/Button/Button"
import StatusSelector from "../detail/StatusSelector"
import styles from "../../../styles/inventory/technicalSupport.module.css"
import { updateTicketRequestStatus, approveTicketRequest } from "../../../services/inventory/detail"

const SupportRequestDetailModal = ({
  isOpen,
  onClose,
  currentPatient,
  requestData,
  ticket,
  ticketType = "ticket-request",
  footerButtons = [],
  onStatusChange,
}) => {
  const [isForwarding, setIsForwarding] = useState(false)
  const [ticketStatus, setTicketStatus] = useState(ticket?.status || "pending")
  const statusSelectorRef = useRef(null)

  // Update internal status when ticket changes
  useEffect(() => {
    setTicketStatus(ticket?.status || "pending")
    setIsForwarding(false)
  }, [ticket])

  const statusColorMap = useMemo(() => {
    return ticketType === "ticket-request"
      ? { pending: { color: "#fef3c7", text: "#d97706", dotColor: "#d97706" }, canceled: { color: "#fee2e2", text: "#dc2626", dotColor: "#dc2626" } }
      : { open: { color: "#fee2e2", text: "#dc2626", dotColor: "#dc2626" }, resolved: { color: "#dcfce7", text: "#16a34a", dotColor: "#16a34a" }, closed: { color: "#f3f4f6", text: "#6b7280", dotColor: "#6b7280" } }
  }, [ticketType])

  const handleStatusChange = async (newStatus) => {
    if (!ticket?.id) return
    try {
      const res = await updateTicketRequestStatus(ticket.id, newStatus)
      if (res.success) {
        setTicketStatus(newStatus) 
        if (onStatusChange) onStatusChange(newStatus, ticket) 
      } else {
        alert(res.message || "Failed to update status")
      }
    } catch (err) {
      console.error(err)
      alert("Error updating status")
    }
  }

  const handleForwardAction = async () => {
    if (!ticket?.id) return
    setIsForwarding(true)
    try {
      const result = await approveTicketRequest(ticket.id)
      if (result.success) {
        alert(`Ticket Request ${ticket.requestId} forwarded successfully`)
        setTicketStatus("forwarded")
        if (onStatusChange) onStatusChange("forwarded", ticket)
      } else {
        alert(result.message)
      }
    } catch (err) {
      console.error(err)
      alert("Error forwarding ticket")
    } finally {
      setIsForwarding(false)
    }
  }

  const patientInfoData = [
    { label: "Patient Name", value: ticket?.patientName || `${currentPatient?.user?.first_name || ""} ${currentPatient?.user?.last_name || ""}` },
    { label: "Time Zone", value: ticket?.timeZone || "UTC +5" },
    { label: "Email", value: ticket?.email || currentPatient?.user?.email || "N/A" },
    { label: "Phone", value: ticket?.contact || currentPatient?.user?.primary_phone || "N/A" },
  ]

  const deviceInformationData = [
    { label: "Gateway ID / IMEI", value: ticket?.gatewayId || ticket?.serialNumber || "N/A" },
    { label: "Device Type", value: ticket?.deviceType || ticket?.type || "N/A" },
    { label: "Description", value: ticket?.issue || requestData?.description || "N/A" },
  ]

  if (!ticket) return null

  return (
    <Modal
      key={ticket.id}
      title={`Ticket Request Deatails`}
      isOpen={isOpen}
      onClose={onClose}
      width="800px"
      height="auto"
      footer={
        <div className={styles.modal_footer_buttons}>
          {(footerButtons.length > 0 ? footerButtons : [
            { label: "Close", variant: "secondary", onClick: onClose },
            {
              label: isForwarding ? "Forwarding..." : "Forward to Tenovi",
              variant: "primary",
              onClick: handleForwardAction,
              disabled: isForwarding || ticketStatus === "forwarded",
            },
          ]).map((btn, i) => (
            <Button key={i} variant={btn.variant} onClick={btn.onClick} disabled={btn.disabled}>
              {btn.label}
            </Button>
          ))}
        </div>
      }
    >
      <div className={styles.detail_modal_content}>
        <div className={styles.status_section}>
          <span className={styles.status_label}>Status:</span>
          <StatusSelector
            ref={statusSelectorRef}
            id={ticket.id}
            currentStatus={ticketStatus} 
            onStatusChange={handleStatusChange}
            statusColorMap={statusColorMap}
            disabled={false}
          />
        </div>
        <div className={styles.ticket_type_section}>
          <span className={styles.ticket_type_label}>Type:</span>
          <span className={styles.ticket_type_value}>Ticket Request</span>
        </div>

        <InfoCard title="Patient Information" data={patientInfoData} />
        <InfoCard title="Device Information" data={deviceInformationData} />
      </div>
    </Modal>
  )
}

export default SupportRequestDetailModal
